<template>
  <div class="credit">
    <nav class="credit-nav">
      <div class="credit-nav-item" style="flex: 4">时间</div>
      <div class="credit-nav-item" style="flex: 3">积分</div>
      <div class="credit-nav-item" style="flex: 3">描述</div>
    </nav>
    <div class="empty-data" v-if="!haveData">
      <div>
        <i class="iconfont icon-similarproduct"></i>
      </div>
      <div>
        <p>暂无数据</p>
      </div>
    </div>
    <div class="credit-content" v-for="item in credits" :key="item._id">
      <div class="credit-content-item" style="flex: 4">{{item.time}}</div>
      <div class="credit-content-item" :class="item.classStr" style="flex: 3">{{item.creditStr}}</div>
      <div class="credit-content-item desc">{{item.remark}}</div>
    </div>
    <div class="weui-footer" v-if="!haveData">
      <p class="weui-footer__links">
        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
      </p>
      <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import weui from "weui.js";

export default {
  data() {
    return {
      haveData: true,
      year: moment().format("YYYY"),
      credits: []
    };
  },
  created() {
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        let openid = response.data.data.openid;

        // 获取当前用户的金额明细
        axios
          .get("/api/creditscore/wxlist")
          .then(res => {
            if (res.data.success) {
              this.credits = res.data.data;
              if (this.credits.length == 0) {
                this.haveData = false;
              } else {
                for (let i = 0; i < this.credits.length; i++) {
                  this.credits[i].time = moment(this.credits[i].createdAt).format(
                    "YYYY-MM-DD HH:mm"
                  );
                  let creditStr = "";
                  if (this.credits[i].type == 1) {
                    this.credits[i].creditStr =
                      "+ " + this.credits[i].score + " 分";
                    this.credits[i].classStr = "add";
                  } else {
                    this.credits[i].creditStr =
                      "- " + Math.abs(this.credits[i].score) + " 分";
                    this.credits[i].classStr = "reduce";
                  }
                }
              }
            } else {
              weui.alert("获取资金流水失败");
            }
          })
          .catch(err => {
            weui.alert("获取资金流水失败");
          });
      })
      .catch(error => {
        weui.alert("获取用户信息失败");
      });
  }
};
</script>

<style scoped>
.credit {
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
}
.credit-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  margin-bottom: 10px;
}
.credit-nav-item {
  flex: 1;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
  font-weight: bold;
}
.credit-nav-item:last-child {
  border-right: none;
}
.credit-content {
  display: flex;
  line-height: 40px;
  border-top: 1px solid #eee;
}
.credit-content + .credit-content {
  border-top: none;
}
.credit-content:nth-child(2n) {
  background-color: #f0f0f0;
}
.credit-content-item {
  flex: 1;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.credit-content-item:last-child {
  border-right: none;
}
.add {
  color: #1aad19;
}
.reduce {
  color: orangered;
}
.empty-data {
  text-align: center;
  margin-top: 50px;
}
.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}
.empty-data div p {
  font-size: 30px;
  color: #cccccc;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.desc {
  flex: 3; 
  line-height: 22px; 
  text-align: left;
  padding: 4px;
}
</style>




// WEBPACK FOOTER //
// src/components/infos/CreditscoreDetail.vue